// extracted by mini-css-extract-plugin
export default {"page":"V0G5fnquLTmaLu70v0wm","couponImg":"yY_UNmM2VWRc5EdAdh4V","info":"cuGLNvMVLFNwuZ_3JRMI"};